import { memo } from 'react';

import { useLanguage } from 'assets/languages';
import DateInput from 'components/dateInput/dateInput';
import TextInputField from 'components/textInput';
import CampaignFormField, {
  CampaignFormFieldProps,
} from '../../../../../../campaignFormFieldGroup/components/campaignFormField/campaignFormField';

interface PeriodFieldProps
  extends Pick<CampaignFormFieldProps, 'label' | 'description' | 'descriptionClassName' | 'description2' | 'description2ClassName'> {
  startDate: string | Date;
  endDate?: string | Date;
  minStartDate?: string | Date;
  minEndDate?: string | Date;
  maxStartDate?: string | Date;
  startDatePlaceholder?: string;
  endDatePlaceholder?: string;
  isReadOnlyStartDate?: boolean;
  onChangeStartDate?: (value: string) => void;
  onChangeEndDate?: (value: string) => void;
  startDateCalendarHeader?: () => React.ReactNode;
  endDateCalendarHeader?: () => React.ReactNode;
  checkBox?: () => React.ReactNode;
  tileDisabled?: ({ activeStartDate, date, view }: any) => boolean;
}

const PeriodField = ({
  label,
  description,
  descriptionClassName,
  description2,
  description2ClassName,
  minStartDate,
  minEndDate,
  maxStartDate,
  startDate,
  endDate,
  startDatePlaceholder,
  endDatePlaceholder,
  isReadOnlyStartDate,
  onChangeStartDate,
  onChangeEndDate,
  startDateCalendarHeader,
  endDateCalendarHeader,
  checkBox,
  tileDisabled,
}: PeriodFieldProps) => {
  const language = useLanguage();
  const languageTexts = { ...language.common };

  return (
    <CampaignFormField
      as="div"
      label={label}
      description={description}
      descriptionClassName={descriptionClassName}
      description2={description2}
      description2ClassName={description2ClassName}
    >
      {checkBox != null ? checkBox() : null}
      <div className="flex flex-row items-center gap-3">
        {isReadOnlyStartDate ? (
          <TextInputField
            className="flex-1"
            disabled
            placeholder={startDatePlaceholder || languageTexts.start_date}
            value={startDate}
          />
        ) : (
          <DateInput
            className="flex-1"
            calenderHeader={startDateCalendarHeader}
            placeholder={startDatePlaceholder || languageTexts.start_date}
            minDate={minStartDate}
            maxDate={maxStartDate}
            value={startDate}
            onChange={onChangeStartDate}
            tileDisabled={tileDisabled}
          />
        )}
        {endDate !== undefined && (
          <>
            <span>~</span>
            <DateInput
              className="flex-1"
              calenderHeader={endDateCalendarHeader}
              placeholder={endDatePlaceholder || languageTexts.end_date}
              minDate={minEndDate}
              value={endDate}
              onChange={onChangeEndDate}
              tileDisabled={tileDisabled}
            />
          </>
        )}
      </div>
    </CampaignFormField>
  );
};

export default memo(PeriodField);
